import React from 'react';
import TwoColumnImageRight from './TwoColumnImageRight';
import PersonalisedTwoColumnImageRight from './PersonalisedTwoColumnImageRight';
import TwoColumnImageRightV2 from './TwoColumnImageRightV2';
import TwoColumnImageLeft from './TwoColumnImageLeft';
import TwoColumnImageLeftV2 from './TwoColumnImageLeftV2';
import TabsTwoColumnImageLeft from './TabsTwoColumnImageLeft';
import TabsTwoColumnImageLeftV2 from './TabsTwoColumnImageLeftV2';
import TabsTwoColumnImageRight from './TabsTwoColumnImageRight';
import TabsTwoColumnImageRightV2 from './TabsTwoColumnImageRightV2';


const TwoColumn = ({ twoColumnContent }) => {
    if (!twoColumnContent)
        return '';  
       
    if (twoColumnContent.__typename === 'Contentstack_2_col_image_right')
        return (<TwoColumnImageRight twoColumnImageRightContent={twoColumnContent} />);
    if (twoColumnContent.__typename === 'Contentstack_personalised_2_col_image_right')
        return (<PersonalisedTwoColumnImageRight twoColumnImageRightContent={twoColumnContent} />);

    if (twoColumnContent.__typename === 'Contentstack_2_col_image_right_v2')
        return (<TwoColumnImageRightV2 twoColumnImageRightContent={twoColumnContent} />);
    
    if (twoColumnContent.__typename === 'Contentstack_2_col_image_left')
        return(<TwoColumnImageLeft twoColumnImageLeftContent={twoColumnContent} />);

    if (twoColumnContent.__typename === 'Contentstack_2_col_image_left_v2')
        return(<TwoColumnImageLeftV2 twoColumnImageLeftContent={twoColumnContent} />);

    if (twoColumnContent.__typename === 'Contentstack_tabs_two_column_layout_image_right')
        return (<TabsTwoColumnImageRight tabsTwoColumnImageRightContent={twoColumnContent} />);

    if (twoColumnContent.__typename === 'Contentstack_tabs_two_column_layout_image_right_v2')
        return (<TabsTwoColumnImageRightV2 tabsTwoColumnImageRightV2Content={twoColumnContent} />);
    
    if (twoColumnContent.__typename === 'Contentstack_tabs_2_col_layout_image_left') {
        return (<TabsTwoColumnImageLeft tabsTwoColumnImageLeftContent={twoColumnContent} />);
    }

    if (twoColumnContent.__typename === 'Contentstack_tabs_two_column_layout_image_left_v2') {
        return (<TabsTwoColumnImageLeftV2 tabsTwoColumnImageLeftV2Content={twoColumnContent} />);
    }
    
    return '';
}

export default TwoColumn;